import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "button-content" }
const _hoisted_2 = {
  key: 0,
  class: "spotify-icon",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}

import { computed } from 'vue';
import { useSpotifyAuth } from '@/composables/useSpotifyAuth';
import PrimaryButton from '@/components/UI/PrimaryButton.vue';

interface Props {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SpotifyConnectButton',
  props: {
    variant: { default: 'primary' },
    size: { default: 'md' },
    fullWidth: { type: Boolean, default: false }
  },
  setup(__props: any) {



const { login, isAuthenticated, userProfile } = useSpotifyAuth();

const buttonText = computed(() => {
  if (isAuthenticated.value && userProfile.value) {
    return `Verbunden als ${userProfile.value.display_name}`;
  }
  return 'Mit Spotify verbinden';
});

function handleConnect() {
  if (!isAuthenticated.value) {
    login();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PrimaryButton, {
    variant: __props.variant,
    size: __props.size,
    "full-width": __props.fullWidth,
    onClick: handleConnect
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        (!_unref(isAuthenticated))
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("path", { d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(buttonText.value), 1)
      ])
    ]),
    _: 1
  }, 8, ["variant", "size", "full-width"]))
}
}

})